<template>
  <div>
    <Echart :options="options" id="centreLeft1Chart" :height="height + 'px'" width="25vw"></Echart>
  </div>
</template>

<script>
import Echart from '@/common/echart'
export default {
  data() {
    return {
      options: {},
      height: '180'
    };
  },
  components: {
    Echart,
  },
  props: {
    cdata: {
      type: Object,
      default: () => ({})
    },
  },
  watch: {
    cdata: {
      handler(newData) {
        let total = newData.seriesData.reduce(function (total, currentValue, currentIndex, arr) {
                      return total + currentValue.value;
                  }, 0);
        // 中山大学第八医院大屏那个数据改为75369
        // let info = localStorage.getItem('userInfo')
        // if(JSON.parse(info).customerId == 252){
        //   total = 75369
        // }
        this.options = {
          title: {
            text: total,
            left: 'center',
            top: '35%',
            textStyle: {
              fontWeight: 'bold',
              fontSize: '10',
              color:'#00cdff'
            }
          },
          color: [
          

            "#37a2da",
            "#6871d0",
            "#4d9f88",
            "#ffdb5c",
            "#006de6",
            "#00d2f5",
            "#e7bcf3",
            "#8378ea"
          ],
          tooltip: {
            trigger: "item",
            formatter: "{a} <br/>{b} : {c} ({d}%)"
          },
          toolbox: {
            show: true
          },
          calculable: true,
          legend: {
            orient: "horizontal",
            icon: "circle",
            bottom: 10,
            x: "center",
            data: newData.xData,
            itemHeight: 7, //修改icon图形大小
            textStyle: {
              color: "#fff",
              fontSize: 10
            }
          },
          series: [
            {
              name: "",
              type: "pie",
              radius: [20, 35],
              // roseType: "area",
              center: ["50%", "40%"],
              data: newData.seriesData,

              label: {
                normal: {
                  textStyle: {
                    fontSize: 10,
                    color: '#fff'
                  },
                  formatter: function (params) {
                    // console.log(params, '--------')
                    return params.name + ':' + (parseInt(params.percent)) + '% ' + params.value + '件'
                  },
                }

              },
              labelLine: {
                normal: {
                  length: 10, //第一条线
                  length2: 15, //第二条线
                  lineStyle: {
                    width: 1, // 线条的宽度
                    // color: "#000", //线的颜色设置， 如没有设置颜色则线条的颜色跟随饼状图的颜色
                  }
                }
              }
            }
          ]
        }

        if(this.$screenWidth >= 1520){
          this.height = 280
          this.options.title.textStyle.fontSize = 16
          this.options.title.top = '40%'
          this.options.legend.textStyle.fontSize = 14
          this.options.legend.bottom = 50

          this.options.series[0].radius = ['25%', '50%']
          this.options.series[0].center = ["50%", "44%"]

          this.options.series[0].label.normal.textStyle.fontSize = 14
        }else if(this.$screenWidth >=1400 && this.$screenWidth < 1520){
          this.height = 200
          this.options.title.textStyle.fontSize = 14
          this.options.title.top = '35%'
          this.options.legend.textStyle.fontSize = 12
          this.options.series[0].radius = ['25%', '45%']
          this.options.series[0].center = ["50%", "40%"]
        }else{
          this.height = 180
        }

        // console.log('window.innerWidth',window.innerWidth,  )
        // console.log('window.innerHeight',window.innerHeight)

      },
      immediate: true,
      deep: true
    }
  }
};
</script>

<style lang="scss" scoped></style>